export default __webpack_public_path__ + "static/aws-certified-solutions-architect-associate-22fb7f03460dd4843feb3574899c8ced.png";